module.exports = __webpack_public_path__ + "static/easiest-admin-1acd5a6cc302570d79cc294dbaf340aa.svg";